import React, { useState } from 'react';
import colors from '../../utils/colors';

const ToggleButton = ({ isActive = false, onToggle, className = "", children, text, leftIcon, rightIcon }) => {
  const [active, setActive] = useState(isActive);

  const handleToggle = () => {
    const newActive = !active;
    setActive(newActive);
    if (onToggle) {
      onToggle(newActive);
    }
  };

  const getIconColor = () => {
    return active ? (colors.accent || '#FD429C') : (colors.text.inactive || '#726E6C');
  };

  const getButtonStyle = () => {
    if (active) {
      return {
        backgroundColor: colors.text.primary,
        borderColor: colors.text.primary
      };
    } else {
      return {
        backgroundColor: 'transparent',
        borderColor: colors.border.primary
      };
    }
  };

  return (
    <button
      onClick={handleToggle}
      className={`flex justify-center items-center gap-1 h-10 px-3 py-2 rounded-full border transition-colors ${className}`}
      style={getButtonStyle()}
    >
      {leftIcon && (
        <div className="w-4 h-4 flex items-center justify-center" style={{ color: getIconColor() }}>
          {leftIcon}
        </div>
      )}
      {children}
      {text && (
        <p
          className="text-xs font-medium"
          style={{ color: active ? colors.bg.primary : colors.text.primary }}
        >
          {text}
        </p>
      )}
      {rightIcon && (
        <div className="w-4 h-4 flex items-center justify-center" style={{ color: active ? colors.bg.primary : colors.text.primary }}>
          {rightIcon}
        </div>
      )}
    </button>
  );
};

export default ToggleButton;